<template>
  <div class="company-list-for-mailing">
    <b-table
      ref="companyListForMailingTable"
      id="companyListForMailingTable"
      :items="tableItems"
      :fields="tableFields"
      thead-class="thead-color"
      hover
      selectable
      select-mode="multi"
      responsive
      stacked="md"
      @row-selected="onRowSelected"
    >
      <template #head(selected)="data">
        <b-form-checkbox
          v-model="selectAll"
          @change="toggleSelectAll"
          aria-label="Выбрать все"
          title="Выбрать все"
          style="margin-top: 5px;"
        >
        </b-form-checkbox>
      </template>

      <!-- Selection Column -->
      <template #cell(selected)="{ rowSelected, data }">
        <div class="text-center">
          <template v-if="rowSelected">
            <span class="font-size-12 font-weight-bold">&check;</span>
          </template>
          <template v-else>
            <span class="font-size-12 text-muted-deep">&check;</span>
          </template>
        </div>
      </template>
      
      <!-- Index Column -->
      <template #cell(index)="data">
        <div class="text-center">{{ data.index + 1 }}</div>
      </template>

      <!-- Custom Data Columns -->
      <template #cell(lead_segments)="data">
        <div class="small-td-table"><span class="no-wrap" v-html="byNameObjectGlueOutput(data.item.segments, '<br>')"></span></div>
      </template>
      <template #cell(set_services_ids)="data">
        <div class="small-td-table"><span class="no-wrap" v-html="referencePropertyArrayGlueOutput(data.item.set_services_ids, '<br>')"></span></div>
      </template>
      <template #cell(set_special_features_ids)="data">
        <div class="small-td-table"><span class="no-wrap" v-html="referencePropertyArrayGlueOutput(data.item.set_special_features_ids, '<br>')"></span></div>
      </template>
      <template #cell(set_transit_directions_ids)="data">
        <div class="small-td-table"><span class="no-wrap" v-html="referencePropertyArrayGlueOutput(data.item.set_transit_directions_ids, '<br>')"></span></div>
      </template>
      <template #cell(set_rf_directions_ids)="data">
        <div class="small-td-table"><span class="no-wrap" v-html="referencePropertyArrayGlueOutput(data.item.set_rf_directions_ids, '<br>')"></span></div>
      </template>
      <template #cell(set_countries_of_branches_ids)="data">
        <div class="small-td-table"><span v-html="referencePropertyArrayGlueOutput(data.item.set_countries_of_branches_ids, ', ')"></span></div>
      </template>
      <template #cell(set_countries_of_rolling_stock_ids)="data">
        <div class="small-td-table"><span v-html="referencePropertyArrayGlueOutput(data.item.set_countries_of_rolling_stock_ids, ', ')"></span></div>
      </template>
      <template #cell(type_of_company_ts)="data">
        <div class="small-td-table"><span class="no-wrap" v-html="arrayGlueOutput(data.item.type_of_company_ts, '<br>')"></span></div>
      </template>
      <template #cell(kind_of_company_ts)="data">
        <div class="small-td-table"><span class="no-wrap" v-html="arrayGlueOutput(data.item.kind_of_company_ts, '<br>')"></span></div>
      </template>
      <template #cell(set_uploading_geography_ids)="data">
        <div class="small-td-table"><span v-html="referencePropertyArrayGlueOutput(data.item.set_uploading_geography_ids, ', ')"></span></div>
      </template>
      <template #cell(set_unloading_geography_ids)="data">
        <div class="small-td-table"><span v-html="referencePropertyArrayGlueOutput(data.item.set_unloading_geography_ids, ', ')"></span></div>
      </template>
      <template #cell(set_transport_data)="data">
        <div 
          v-for="(category, category_name) in transportArrayGroupedByType(data.item.set_transport_data)"
          :key="category_name"
          class="small-td-table"
        >
          <b>{{ category_name }}</b>: <span v-html="transportArrayGlueOutput(category)"></span>
        </div>
      </template>
      <template #cell(set_insurance_data)="data">
        <div class="small-td-table"><span v-html="referencePropertyArrayGlueOutput(data.item.set_insurance_data, '<br>')"></span></div>
      </template>
      <template #cell(company_employee_contacts)="data">
        <template v-if="data.item.company_employees.length == 0">—</template>
        <template v-else>
          <div v-for="contact in prepareEmployees(data.item.company_employees)" class="small-td-table">
            <b class="name">{{ contact.lead_fio }}</b> <i class="fas fa-copy copy-icon" @click="copyToClipboardInTable(contact.lead_fio)"></i><br>
            <span v-if="contact.lead_phone">
              <a :href="`tel:+${contact.lead_phone}`">+{{ contact.lead_phone }}</a>
              <i class="fas fa-copy copy-icon" @click.stop="copyToClipboardInTable(contact.lead_phone)"></i>
              <br>
            </span>
            <span v-if="contact.lead_company_phone">
              {{ contact.lead_company_phone }}
              <i class="fas fa-copy copy-icon" @click.stop="copyToClipboardInTable(contact.lead_company_phone)"></i>
              <br>
            </span>
            <span v-if="contact.lead_email">
              <a :href="`mailto:${contact.lead_email}`">{{ contact.lead_email }}</a>
              <i class="fas fa-copy copy-icon" @click.stop="copyToClipboardInTable(contact.lead_email)"></i>
              <br>
            </span>
            <span v-if="contact.lead_segments">{{ contact.lead_segments }}</span>
          </div>
        </template>
      </template>
    </b-table>
  </div>
</template>

<script>
import { tablePrepareData } from '@/mixins';

export default {
  props: {
    items: {
      type: Object,
      required: true,
    },
    selectedItems: {
      type: Array,
      required: true,
    },
  },

  mixins: [
    tablePrepareData
  ],  

  data() {
    return {
      tableItems: [],
      tableFields: [],
      selectAll: false
    };
  },

  watch: {
    selectedItems: {
      deep: true,
      immediate: true,
      handler(newSelectedItems) {
        this.autoSelectTableItems(newSelectedItems);
      },
    },
  },

  mounted() {
    this.prepareTableData();
  },

  methods: {
    prepareTableData() {
      this.tableItems = this.items.data;

      this.tableFields = [
        { key: 'selected', label: '✓', class: 'table-small-td' }, // Selection column
        { key: 'index', label: '№', class: 'table-small-td' }, // Index column
        ...this.items.headers.map(header => {
          return {
            key: header.key,
            label: header.label,
            sortable: ['id', 'name'].includes(header.key) ? header.sortable : false,
            stickyColumn: header.stickyColumn,
            class: header.class,
            thStyle: header.stickyColumn ? { position: 'sticky', left: '0', zIndex: '1020' } : {},
            headerAlign: header.headerAlign || 'left',
          };
        })
      ];

      this.autoSelectTableItems(this.selectedItems);
    },
    autoSelectTableItems(newSelectedItems) {
      this.$nextTick(() => {
        this.$refs.companyListForMailingTable.clearSelected();

        this.tableItems.forEach((item, index) => {
          if (newSelectedItems.includes(item.id)) {
            this.$refs.companyListForMailingTable.selectRow(index);
          }
        });

        this.selectAll = newSelectedItems.length === this.tableItems.length && this.tableItems.length > 0;
      });
    },
    onRowSelected(selectedRows) {
      this.$emit('updateSelectedItems', {
        'selectedItems': selectedRows.map(row => row.id), 
        'items': this.items
    });
    },
    toggleSelectAll() {
      let selectedItems = [];

      if (this.selectAll) {
        selectedItems = this.tableItems.map(item => item.id);
      }

      this.$emit('updateSelectedItems', {
        'selectedItems': selectedItems, 
        'items': this.items
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.small-td-table {
  font-size: 12px;
}
</style>
